/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeleteApplicationInput = {
    applicationId: string;
};
export type Applications_deleteApplication_MutationVariables = {
    input: DeleteApplicationInput;
};
export type Applications_deleteApplication_MutationResponse = {
    readonly deleteApplication: {
        readonly application: {
            readonly id: string;
        };
    } | null;
};
export type Applications_deleteApplication_Mutation = {
    readonly response: Applications_deleteApplication_MutationResponse;
    readonly variables: Applications_deleteApplication_MutationVariables;
};



/*
mutation Applications_deleteApplication_Mutation(
  $input: DeleteApplicationInput!
) {
  deleteApplication(input: $input) {
    application {
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteApplicationPayload",
    "kind": "LinkedField",
    "name": "deleteApplication",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Application",
        "kind": "LinkedField",
        "name": "application",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Applications_deleteApplication_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Applications_deleteApplication_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c9135f38dd8552d9be53eae0874a6285",
    "id": null,
    "metadata": {},
    "name": "Applications_deleteApplication_Mutation",
    "operationKind": "mutation",
    "text": "mutation Applications_deleteApplication_Mutation(\n  $input: DeleteApplicationInput!\n) {\n  deleteApplication(input: $input) {\n    application {\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '84f47ad70ae1d9b9b5c55cf4a61bc0a5';
export default node;
